import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import AnimatedSection from './AnimatedSection';
import { trackButtonClick } from '../utils/analytics';

const HeroWithBanner = ({ onOpenPopup }) => {
  const handleGetStartedClick = () => {
    trackButtonClick('get_started_signup', 'hero_banner');
    window.open('https://app.tallybharat.com/sign-up', '_blank');
  };

  const handleDemoClick = () => {
    trackButtonClick('request_demo', 'hero_banner');
    onOpenPopup();
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0A1F44] via-[#0056D2] to-[#0A1F44] pt-20">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#FF7A00] rounded-full opacity-10 blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#0056D2] rounded-full opacity-10 blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="text-center lg:text-left">
            <AnimatedSection animation="fadeInUp">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Run Tally Securely From Anywhere
                <br />
                <span className="text-[#FF7A00]">Superfast Cloud Hosting by TallyBharat</span>
              </h1>
            </AnimatedSection>

            <AnimatedSection animation="fadeInUp" delay={200}>
              <p className="text-xl md:text-2xl text-blue-100 mb-10 leading-relaxed">
                Enhanced Security • Multi-User Collaboration • High Performance
              </p>
            </AnimatedSection>

            <AnimatedSection animation="scaleIn" delay={400}>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6">
                <Button
                  onClick={handleGetStartedClick}
                  className="bg-[#FF7A00] hover:bg-[#e66d00] text-white font-semibold px-8 py-6 text-lg rounded-full transition-all duration-200 hover:scale-105 hover:shadow-2xl"
                >
                  Get Started
                  <ArrowRight className="ml-2" size={20} />
                </Button>
                <Button
                  onClick={handleDemoClick}
                  variant="outline"
                  className="bg-white/10 hover:bg-white/20 text-white border-2 border-white font-semibold px-8 py-6 text-lg rounded-full transition-all duration-200 hover:scale-105 backdrop-blur-sm"
                >
                  Request a Demo
                </Button>
              </div>
            </AnimatedSection>
          </div>

          {/* Right Column - Banner Image */}
          <AnimatedSection animation="slideInRight" delay={300}>
            <div className="relative">
              <img
                src="https://tally-bharat.s3.ap-south-1.amazonaws.com/media/tb-media-b5.jpeg"
                alt="Tally on Cloud - Access Anywhere"
                className="w-full h-auto rounded-3xl shadow-2xl"
                style={{ maxWidth: '1200px', maxHeight: '1200px' }}
              />
              {/* Decorative Element */}
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#FF7A00] opacity-20 rounded-3xl -z-10 hidden lg:block" />
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroWithBanner;
